import { Alert, Button, Input } from '@material-tailwind/react';
import { getCookie, removeCookie, setCookie } from '../../../utils/helper';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { allNNotifi, updateNotifis } from '../../../services/apiUsers';

function Notifi() {
  const auth = getCookie('token');
  const [openAlert, setOpenAlert] = useState(false);
  const [arrNotifi, setArrNotifi] = useState({
    title: '',
    link: '',
    status: 1,
  });
  useEffect(() => {
    document.title = 'Cập nhật thông báo';
    getAllNotifi();
  }, []);

  const getAllNotifi = async () => {
    const resultAPISIM = await allNNotifi();
    if (resultAPISIM.length > 0) {
      let arr = { id: resultAPISIM[0]['id'], title: resultAPISIM[0]['title'], link: resultAPISIM[0]['link'] };
      setArrNotifi(arr);
    }
  };

  const updateNotifi = async () => {
    let body = {
      id: arrNotifi.id,
      data: arrNotifi,
    };
    const resultAPISIM = await updateNotifis(body);
    if (resultAPISIM?.message === 'OK') {
      setOpenAlert(true);
    } else {
      setOpenAlert(false);
    }
  };
  return (
    <div>
      <Alert color={'green'} className="mb-2" open={openAlert} onClose={() => setOpenAlert(false)}>
        {' '}
        CẬP NHẬT THÀNH CÔNG
      </Alert>
      <h3 className="font-bold mb-1">CẬP NHẬT THÔNG BÁO</h3>
      <div className="grid grid-cols-1 gap-3">
        <div className="col-span-2">
          <Input
            value={arrNotifi.title}
            label="Tiêu đề"
            onChange={(e) => {
              setArrNotifi({ ...arrNotifi, title: e.target.value });
            }}
          />
        </div>
        <div className="col-span-2">
          <Input
            value={arrNotifi.link}
            label="Link chuyến hướng (nếu có)"
            onChange={(e) => {
              setArrNotifi({ ...arrNotifi, link: e.target.value });
            }}
          />
        </div>
        <div>
          <Button className="bg-gradient-to-r from-orange-400 to-orange-900" onClick={updateNotifi}>
            CẬP NHẬT
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Notifi;
